import {Link} from '@chakra-ui/react';

export default function ChakraLink({children, ...rest}) {
    return <Link {...rest}>{children}</Link>;
}
